import React, { useState, useEffect } from 'react'
import { Card, Input, Button, message, Typography, Tabs } from 'antd'
import { KeyOutlined, UserOutlined, SafetyOutlined, GiftOutlined, LockOutlined, PhoneOutlined } from '@ant-design/icons'
import { backend } from '../api'
import api from '../api'

const { Title, Text } = Typography

export default function LoginPage({ onLogin }) {
  const [mode, setMode] = useState('login')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [code, setCode] = useState('')
  const [phone, setPhone] = useState('')
  const [referralCode, setReferralCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [appConfig, setAppConfig] = useState({ appName: '', appLogo: '' })

  const handleLogin = async () => {
    if (!username.trim()) { message.warning('请输入用户名'); return }
    if (!password.trim() && !code.trim()) { message.warning('请输入密码或激活码'); return }
    setLoading(true)
    try {
      const res = await backend.login(username.trim(), code.trim() || null, password.trim() || null, referralCode.trim() || null)
      if (res.success) {
        sessionStorage.setItem('auth_token', res.token)
        sessionStorage.setItem('auth_user', JSON.stringify(res.user))
        message.success(`欢迎，${res.user.username}`)
        onLogin(res.user)
      } else {
        message.error(res.error || '登录失败')
      }
    } catch (err) {
      message.error('无法连接后端服务，请确认软件已完整启动')
    } finally { setLoading(false) }
  }

  const handleRegister = async () => {
    if (!username.trim()) { message.warning('请输入用户名'); return }
    if (!password.trim() || password.trim().length < 6) { message.warning('密码至少6位'); return }
    if (!/^1[3-9]\d{9}$/.test(phone.trim())) { message.warning('请输入有效手机号'); return }
    setLoading(true)
    try {
      const res = await backend.register(
        username.trim(),
        password.trim(),
        code.trim() || null,
        referralCode.trim() || null,
        phone.trim()
      )
      if (res.success) {
        sessionStorage.setItem('auth_token', res.token)
        sessionStorage.setItem('auth_user', JSON.stringify(res.user))
        message.success(`注册成功，欢迎 ${res.user.username}`)
        onLogin(res.user)
      } else {
        message.error(res.error || '注册失败')
      }
    } catch (err) {
      message.error('无法连接后端服务')
    } finally { setLoading(false) }
  }

  const submitLogin = () => { mode === 'login' ? handleLogin() : handleRegister() }

  useEffect(() => {
    api.getAppConfig().then(cfg => {
      if (cfg) setAppConfig({ appName: cfg.appName || '', appLogo: cfg.appLogo || '' })
    })
  }, [])

  return (
    <div style={{
      width: '100vw', height: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Card style={{ width: 420, borderRadius: 12, boxShadow: '0 8px 40px rgba(0,0,0,0.25)' }}
        styles={{ body: { padding: '32px 36px' } }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 14, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px',
            boxShadow: '0 4px 16px rgba(102,126,234,0.4)'
          }}>
            {appConfig.appLogo ? (
              <img src={appConfig.appLogo} alt="Logo" style={{ width: 32, height: 32, borderRadius: 4, objectFit: 'contain' }} />
            ) : (
              <SafetyOutlined style={{ fontSize: 28, color: '#fff' }} />
            )}
          </div>
          <Title level={3} style={{ margin: 0 }}>{appConfig.appName || '新媒体运营之家·矩阵'}</Title>
          <Text type="secondary">多平台账号矩阵管理系统</Text>
        </div>

        <Tabs activeKey={mode} onChange={setMode} centered items={[
          { key: 'login', label: '登录' },
          { key: 'register', label: '注册' }
        ]} style={{ marginBottom: 8 }} />

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Input size="large" prefix={<UserOutlined />} placeholder="用户名"
            value={username} onChange={e => setUsername(e.target.value)}
            onPressEnter={submitLogin} />

          {mode === 'register' && (
            <>
              <Input.Password size="large" prefix={<LockOutlined />} placeholder="设置密码（至少6位）"
                value={password} onChange={e => setPassword(e.target.value)}
                onPressEnter={submitLogin} />
              <Input size="large" prefix={<PhoneOutlined />} placeholder="手机号（用于后期服务）"
                value={phone} onChange={e => setPhone(e.target.value)}
                onPressEnter={submitLogin} />
            </>
          )}

          {mode === 'login' ? (
            <Input.Password size="large" prefix={<LockOutlined />}
              placeholder="方式一：登录密码"
              value={password} onChange={e => setPassword(e.target.value)}
              onPressEnter={submitLogin} />
          ) : null}

          {mode === 'login' ? (
            <Input.Password size="large" prefix={<KeyOutlined />}
              placeholder="方式二：已绑定激活码"
              value={code} onChange={e => setCode(e.target.value)}
              onPressEnter={submitLogin} />
          ) : (
            <Input size="large" prefix={<KeyOutlined />}
              placeholder="激活码（未填写则无使用时长）"
              value={code} onChange={e => setCode(e.target.value)}
              onPressEnter={submitLogin} />
          )}

          <Input size="large" prefix={<GiftOutlined />}
            placeholder="推荐码（选填）"
            value={referralCode} onChange={e => setReferralCode(e.target.value)}
            onPressEnter={submitLogin} />

          <Button type="primary" size="large" block loading={loading}
            onClick={submitLogin}
            style={{ height: 44, borderRadius: 8, fontWeight: 500 }}>
            {mode === 'login' ? '登录' : '注册'}
          </Button>

          <Text type="secondary" style={{ fontSize: 12, textAlign: 'center', display: 'block' }}>
            {mode === 'login'
              ? '用户名+密码、用户名+已绑定激活码，两种方式均可登录'
              : '注册需填写手机号，注册后可使用激活码开通使用时长'}
          </Text>
        </div>
      </Card>
    </div>
  )
}
